var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[(_vm.background)?_c('img',{staticClass:"img",attrs:{"src":_vm.background,"alt":"bg"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }